import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import AppFormInput from "../../../../components/form/AppFormInputs/AppFormInput";

interface PassengerNameFieldsProps {
  firstName: string;
  lastName: string;
  firstNameField?: string;
  lastNameField?: string;
  onFirstNameChange: (event: any) => void;
  onLastNameChange: (event: any) => void;
  /** MUI Grid md width for each name field. Defaults to 3 (SBB 4-column layout). */
  md?: number;
  /** MUI Grid xs/sm width when stacked. Defaults to 2.5 used by some forms; SBB uses 12 via fullWidthMobile. */
  sm?: number;
  xs?: number;
  firstNameError?: boolean;
  lastNameError?: boolean;
}

/**
 * Shared first/last name inputs used by rail passenger rows.
 */
export default function PassengerNameFields({
  firstName,
  lastName,
  firstNameField = "first_name",
  lastNameField = "last_name",
  onFirstNameChange,
  onLastNameChange,
  md = 3,
  sm = 12,
  xs = 12,
  firstNameError = false,
  lastNameError = false
}: PassengerNameFieldsProps) {
  const { t } = useTranslation();

  return (
    <>
      <Grid item md={md} sm={sm} xs={xs} mb={{ xs: 2, md: 0 }}>
        <AppFormInput
          placeholder={t("transport.formFirstName")}
          name={firstNameField}
          type="string"
          disabled={false}
          value={firstName}
          onChange={onFirstNameChange}
          required={true}
          error={firstNameError}
        />
      </Grid>
      <Grid item md={md} sm={sm} xs={xs} mb={{ xs: 2, md: 0 }}>
        <AppFormInput
          placeholder={t("transport.formLastName")}
          name={lastNameField}
          type="string"
          disabled={false}
          value={lastName}
          onChange={onLastNameChange}
          required={true}
          error={lastNameError}
        />
      </Grid>
    </>
  );
}
